module.exports = __webpack_public_path__ + "static/media/red-heart.298391b9.svg";